export enum Roles {
    Admin = "admin",
    Caregiver = "caregiver",
    CareRecipient = "carerecipient",
    HealthCareProvider = "healthcareprovider"
}